export enum AffiliateCommissionTypeEnum {
  first_tier = 'first-tier',
  second_tier = 'second-tier',
  next_gen = 'next-gen',
}
